import { Reveal } from "@/components/common";
import { useI18n } from "@/i18n";

// Comparison table -> stacked cards on mobile. Growth column highlighted.
export function PricingTable() {
  const { t } = useI18n();
  const { headers, rows } = t("pricing.comparison");
  const bestChoice = t("pricing.bestChoice");

  return (
    <Reveal delay={0.1} className="mx-auto mt-16 max-w-5xl" >
      <div data-testid="pricing-table">
        {/* Desktop table */}
        <div className="hidden overflow-hidden rounded-3xl border border-re-line bg-white md:block">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-re-line">
                <th className="p-5 text-sm font-medium text-re-muted"></th>
                {headers.map((h, i) => (
                  <th key={h} className="relative p-5">
                    {i === 1 && (
                      <span className="absolute -top-0 left-5 rounded-b-lg bg-gradient-red px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">
                        {bestChoice}
                      </span>                    )}
                    <span className={`font-heading text-lg font-bold ${i === 1 ? "text-gradient-red" : "text-re-ink"}`}>{h}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.label} className="border-b border-re-line last:border-0">
                  <td className="p-5 text-sm font-semibold text-re-charcoal">{r.label}</td>
                  {r.values.map((v, i) => (
                    <td key={i} className={`p-5 text-sm ${i === 1 ? "bg-re-red/[0.04] font-semibold text-re-ink" : "text-re-charcoal"}`}>{v}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile stacked cards */}
        <div className="grid gap-4 md:hidden">
          {headers.map((h, colIdx) => (
            <div
              key={h}
              className={`rounded-2xl border p-5 ${colIdx === 1 ? "border-transparent bg-re-ink" : "border-re-line bg-white"}`}
            >
              <div className="mb-4 flex items-center justify-between">
                <span className={`font-heading text-lg font-bold ${colIdx === 1 ? "text-white" : "text-re-ink"}`}>{h}</span>
                {colIdx === 1 && <span className="rounded-full bg-gradient-red px-2.5 py-0.5 text-[10px] font-bold uppercase text-white">{bestChoice}</span>}
              </div>
              <dl className="space-y-2.5">
                {rows.map((r) => (
                  <div key={r.label} className="flex justify-between gap-4 text-sm">
                    <dt className={colIdx === 1 ? "text-white/50" : "text-re-muted"}>{r.label}</dt>
                    <dd className={`text-right font-medium ${colIdx === 1 ? "text-white" : "text-re-ink"}`}>{r.values[colIdx]}</dd>
                  </div>
                ))}
              </dl>
            </div>
          ))}
        </div>
      </div>
    </Reveal>
  );
}
